import recordingStore from './recording';

export default {
  namespaced: true,
  modules: {
    recording: recordingStore
  }
}
